(function () {
    var customerUserWorkflowConfig = {

        /**
         * Action that will be performed as final step of order creation.
         * After saving addresses, orders, order items, files, etc.
         */
        orderCreationAction: "Approve",

        /**
         * Configures how the app will treat workflow actions.
         *
         * code - particular action code to identify an action.
         * ignore - means the action should be ignored and not rendered in the UI.
         * uiPriority - integer value to specify the 'weight' of the step, where to put it in sorted collection in UI.
         * imageResourceName / PublicImageResourceName - string value specifying the name of the image resource defined
         *                                               in the 'images' collection in the customisation configuration
         * color - Specifies what color to use for the button which is used to present the step.
         *          Possible values are: 'blue', 'green', 'orange', 'red', 'violet', 'yellow', 'grey'. Default is 'grey'.
         * isAllowed - A function that identifies if the workflow action allowed to be executed for the passed in item.
         */
        actions: [
            {
                code: "Approve",
                uiPriority: 405,
                imageResourceName: "approval",
                color: "green",
                isAllowed: function (orderItem) {
                    return orderItem.$model.expectedBy && angular.isDate(orderItem.$model.expectedBy) &&
                        orderItem.$model.expectedBy.getTime() >= new Date(new Date().toDateString()).getTime();
                }
            },
            {code: "BackToApproval", uiPriority: 404, imageResourceName: "approval", color: "yellow"},
            {code: "Design", uiPriority: 405, imageResourceName: "design", color: "green"},
            {code: "AssignToExubit", uiPriority: 406, imageResourceName: "design-exubit", color: "blue"},
            {code: "Review", uiPriority: 405, imageResourceName: "design-review", color: "green"},
            {code: "BackToDesign", uiPriority: 404, imageResourceName: "design", color: "yellow"},
            {code: "Batching", uiPriority: 405, imageResourceName: "batch-create", color: "green"},
            {code: "DesignExubit", uiPriority: 401, imageResourceName: "design-exubit", color: "red"},
            {code: "BackToBatching", uiPriority: 404, imageResourceName: "batch-create", color: "yellow"},
            {code: "PrintScript", uiPriority: 405, imageResourceName: "batch-create", color: "green"},
            {code: "BackToPrintScript", uiPriority: 404, imageResourceName: "batch-create", color: "yellow"},
            {code: "InProgress", uiPriority: 405, color: "green"},
            {code: "BackToInProgress", uiPriority: 404, color: "yellow"},
            //{code: "FreightReady", uiPriority: 500, imageResourceName: "freight-await"},
            {code: "InvoiceAwait", uiPriority: 405, imageResourceName: "invoice-await", color: "green" },
            {code: "BackToInvoiceAwait", uiPriority: 404, imageResourceName: "invoice-await", color: "yellow"},
            {
                code: "FinalProcessing", 
                uiPriority: 405, 
                imageResourceName: "batch-process",
                isAllowed: function (orderItem) {
                    return true; //angular.isDefined(orderItem.$model.order.$model.jsonData.OrderData.InvoiceOrderData);
                },
                color: "green"
            },
            {code: "BackToFinalProcessing", uiPriority: 404, imageResourceName: "batch-process", color: "yellow"},
            {
                code: "Packaging", 
                uiPriority: 405, 
                imageResourceName: "shipping-ready",
                isAllowed: function (orderItem) {
                    return orderItem.$model.customFields.FreightRef && orderItem.$model.customFields.FreightRef !== '';
                },
                color: "green"
            },
            {code: "Shipped", uiPriority: 610, imageResourceName: "shipped", color: "green"},
            {code: "Complete", uiPriority: 510, imageResourceName: "complete", color: "green"},
            {code: "Rejected", uiPriority: 100, imageResourceName: "scrapped", color: "red"},
            {code: "OnHold", uiPriority: 200, imageResourceName: "on-hold", color: "yellow"},
            {code: "Cancelled", uiPriority: 10, imageResourceName: "cancelled", color: "red"}
        ],
        /**
         * Configures how the app will treat workflow steps.
         *
         * code - particular step code to identify a step.
         * ignore - means the step will be ignored by the TrackingClient. Will not be shown on Home screen as a button
         *          to show items at that step. Items at that step will not be shown in the grid tables.
         * uiPriority - integer value to specify the 'weight' of the step, where to put it in sorted collection in UI.
         * imageResourceName / PublicImageResourceName - string value specifying the name of the image resource defined
         *                                               in the 'images' collection in the customisation configuration
         * isFloating - Specifies if the step belongs to a group of 'floating' steps and should be shown separate from
         *              the main workflow underneath as a 'bookmark'
         * color - Specifies what color to use for the button which is used to present the step.
         *          Possible values are: 'blue', 'green', 'orange', 'red', 'violet', 'yellow', 'grey'. Default is 'grey'.
         */
        steps: [
            {code: "OrthoMAN", ignore: true, uiPriority: 1, color: "grey", isFloating: true, noImageOnHomeView: false},
            {code: "Approve", uiPriority: 2, imageResourceName: "approval", noImageOnHomeView: false},
            {code: "Design", uiPriority: 4, imageResourceName: "design", forked: false,  noImageOnHomeView: false},
            {code: "ExubitDesign", uiPriority: 5, imageResourceName: "design-exubit", forked: false,  noImageOnHomeView: false},
            {code: "DesignReview", uiPriority: 6, imageResourceName: "design-review", forked: false,  noImageOnHomeView: false},
			{code: "Batching", uiPriority: 7, imageResourceName: "batch-create", noImageOnHomeView: false },
			{code: "PrintScript", uiPriority: 8, imageResourceName: "print", noImageOnHomeView: false },
            {code: "InProgress", uiPriority: 9, noImageOnHomeView: false },
            //{code: "Production", uiPriority: 10, noImageOnHomeView: false},
            //{
            //    code: "Completed",
            //    uiPriority: 20,
            //    imageResourceName: "complete",
            //    publicImageResourceName: "complete",
            //    forksJoin: false
            //},
            //{code: 'QA', uiPriority: 11, imageResourceName: 'qa', publicImageResourceName: 'in-progress'},
            //{code: 'Packing', uiPriority: 13, imageResourceName: 'packaging'},
            {code: "Rejected", uiPriority: 100, imageResourceName: "scrapped", isFloating: true, color: "red", noImageOnHomeView: false},
            {code: "OnHold", uiPriority: 200, imageResourceName: "on-hold", isFloating: true, color: "yellow", noImageOnHomeView: false},
            {code: "CreateFailed", uiPriority: 205, imageResourceName: "incomplete", isFloating: true, color: "red", noImageOnHomeView: false},
            {code: "Cancelled", ignore: true, imageResourceName: "scrapped", uiPriority: 900, isFloating: true, color: "violet", noImageOnHomeView: false},
            
			{code: "InvoiceAwait", uiPriority: 1000, ignore: false, imageResourceName: "invoice-await", noImageOnHomeView: false},
            {code: "FinalProcessing", uiPriority: 1010, ignore: false, imageResourceName: "batch-process", noImageOnHomeView: false},
            {code: "Packaging", uiPriority: 1020, ignore: false, imageResourceName: "shipping-ready", noImageOnHomeView: false},

            //The 'hide' param allows to not take into account the step count for stats, but allows to search over the items at this step
            {code: "Shipped", uiPriority: 2000, ignore: false, hide:true, color: "green", imageResourceName: "shipped", noImageOnHomeView: false}
        ]
    };

    // the same as customerUserWorkflowConfig, but `Shipped` step is ignored
    var centreUserWorkflowConfig = angular.copy(customerUserWorkflowConfig, {});

    // And modify the 'Shipped' step to be 'ignored' for centre users so they don't see
    // shipped items on their main home screen.
    // This allows to configure different visibility of the particular steps for centre and customers users for example,
    // or even individually for user(s).
    //
    //_.find(centreUserWorkflowConfig.steps, function (s) {
    //    return s.code === "Shipped";
    //}).ignore = true;

    angular.module("env.customConfig.workflow", [
        'env.custom.customModule'
    ])
        .constant("customerUserWorkflowConfig", customerUserWorkflowConfig)
        .constant("centreUserWorkflowConfig", centreUserWorkflowConfig);
})();
